/**
 * Active sync worker handles — shared by worker loop and HUD pause/resume.
 */

type Runner = {
  orderId: number
  workerId: string
  abort: AbortController
}

const runners = new Map<number, Runner>()

export function registerSyncRunner(
  orderId: number,
  workerId: string,
  abort: AbortController
) {
  runners.set(orderId, { orderId, workerId, abort })
}

export function unregisterSyncRunner(orderId: number, workerId?: string) {
  const r = runners.get(orderId)
  if (!r) return
  if (workerId != null && r.workerId !== workerId) return
  runners.delete(orderId)
}

export function getSyncRunner(orderId: number): Runner | undefined {
  return runners.get(orderId)
}
